import { useMutation } from 'react-query'

import { userService } from 'src/services/user.service'

export const useRequest2FAEmailDisable = () => {
  return useMutation(() => userService.request2FAEmailDisable())
}
